(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
(function(){
  var header = document.currentScript ? document.currentScript.closest('.muse-header') : null;
  header = header || document.querySelector('.muse-header');

  if(header){
    window.addEventListener('scroll', function(){
      header.classList.toggle('is-scrolled', window.scrollY > 60);
    });
    var burger = header.querySelector('.muse-header__burger');
    var mobile = header.querySelector('.muse-header__mobile');
    if(burger && mobile){
      burger.addEventListener('click', function(){ mobile.classList.toggle('is-open'); });
    }
    header.querySelectorAll('[data-m-toggle]').forEach(function(btn){
      btn.addEventListener('click', function(){
        btn.closest('.muse-header__m-group').classList.toggle('is-open');
      });
    });
  }

  /* --- Live cart count: hook the page once --- */
  if(window.__museCartHook) return;
  window.__museCartHook = true;

  function museUpdateCount(){
    fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(cart){
        document.querySelectorAll('[data-cart-count]').forEach(function(el){
          if(el.textContent !== String(cart.item_count)){
            el.textContent = cart.item_count;
            el.classList.remove('is-bump');
            void el.offsetWidth;            /* restart animation */
            el.classList.add('is-bump');
          }
        });
      })
      .catch(function(){});
  }

  var cartRE = /\/cart\/(add|change|update|clear)/;

  /* Catch fetch-based adds (Horizon, most themes/apps) */
  var _fetch = window.fetch;
  if(typeof _fetch === 'function'){
    window.fetch = function(){
      var u = arguments[0];
      if(u && u.url) u = u.url;
      var p = _fetch.apply(this, arguments);
      if(typeof u === 'string' && cartRE.test(u)){
        p.then(function(res){ if(res && res.ok) setTimeout(museUpdateCount, 60); }).catch(function(){});
      }
      return p;
    };
  }

  /* Catch XHR-based adds (older apps) */
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url){
    if(typeof url === 'string' && cartRE.test(url)){
      this.addEventListener('load', function(){ setTimeout(museUpdateCount, 60); });
    }
    return _open.apply(this, arguments);
  };

  /* Belt-and-braces: common theme cart events */
  ['cart:update','cart:refresh','cart:change','cart-update','variant:add'].forEach(function(ev){
    document.addEventListener(ev, museUpdateCount);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  var bg = document.currentScript.previousElementSibling;
  var el = document.querySelector('.muse-hero__bg[data-parallax]');
  if(!el) return;
  window.addEventListener('scroll', function(){
    var y = window.scrollY;
    if(y < window.innerHeight){ el.style.transform = 'translateY(' + (y * 0.18) + 'px)'; }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muse-benefit-strip"] && !Shopify.designMode) return;
  try {
    
(function(){
  var els = document.querySelectorAll('.muse-reveal:not([data-observed])');
  if(!('IntersectionObserver' in window)){ els.forEach(function(e){e.classList.add('is-in');}); return; }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { threshold: 0.18 });
  els.forEach(function(e){ e.setAttribute('data-observed','1'); io.observe(e); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muse-category-cards"] && !Shopify.designMode) return;
  try {
    
(function(){
  var els = document.querySelectorAll('.muse-reveal:not([data-observed])');
  if(!('IntersectionObserver' in window)){ els.forEach(function(e){e.classList.add('is-in');}); return; }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { threshold: 0.15 });
  els.forEach(function(e){ e.setAttribute('data-observed','1'); io.observe(e); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muse-collection-grid"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.muse-collection [data-filter-toggle]').forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.stopPropagation();
      var f = btn.closest('[data-filter]');
      var open = f.classList.contains('is-open');
      document.querySelectorAll('.muse-collection [data-filter].is-open').forEach(function(o){o.classList.remove('is-open');});
      if(!open){ f.classList.add('is-open'); }
    });
  });
  document.addEventListener('click', function(){
    document.querySelectorAll('.muse-collection [data-filter].is-open').forEach(function(o){o.classList.remove('is-open');});
  });
  document.querySelectorAll('.muse-collection .muse-filter__panel').forEach(function(p){
    p.addEventListener('click', function(e){ e.stopPropagation(); });
  });
  var sel = document.querySelector('.muse-collection [data-sort]');
  if(sel){
    sel.addEventListener('change', function(){
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', this.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });
  }
  var els = document.querySelectorAll('.muse-collection .muse-reveal');
  if(!('IntersectionObserver' in window)){ els.forEach(function(e){e.classList.add('is-in');}); return; }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); } });
  },{threshold:.08});
  els.forEach(function(e){io.observe(e);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muse-founder"] && !Shopify.designMode) return;
  try {
    
(function(){
  var els = document.querySelectorAll('.muse-reveal:not([data-observed])');
  if(!('IntersectionObserver' in window)){ els.forEach(function(e){e.classList.add('is-in');}); return; }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { threshold: 0.15 });
  els.forEach(function(e){ e.setAttribute('data-observed','1'); io.observe(e); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muse-gallery"] && !Shopify.designMode) return;
  try {
    
(function(){
  var els = document.querySelectorAll('.muse-gallery .muse-reveal');
  if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('is-in')});return;}
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); } });
  },{threshold:.12});
  els.forEach(function(e){io.observe(e)});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muse-newsletter"] && !Shopify.designMode) return;
  try {
    
(function(){
  var els = document.querySelectorAll('.muse-reveal:not([data-observed])');
  if(!('IntersectionObserver' in window)){ els.forEach(function(e){e.classList.add('is-in');}); return; }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { threshold: 0.2 });
  els.forEach(function(e){ e.setAttribute('data-observed','1'); io.observe(e); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muse-preloader"] && !Shopify.designMode) return;
  try {
    
(function(){
  var el = document.getElementById('muse-preloader');
  if(!el) return;
  var once = el.dataset.once === 'true';
  if(once && sessionStorage.getItem('musePreloaderShown')){ el.style.display='none'; return; }
  var dur = parseInt(el.dataset.duration, 10) || 1900;
  window.addEventListener('load', function(){
    setTimeout(function(){
      el.classList.add('muse-preloader--done');
      if(once){ sessionStorage.setItem('musePreloaderShown','1'); }
      setTimeout(function(){ el.style.display='none'; }, 900);
    }, dur);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muse-stats"] && !Shopify.designMode) return;
  try {
    
(function(){
  var els = document.querySelectorAll('.muse-reveal:not([data-observed])');
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.15 });
    els.forEach(function(e){ e.setAttribute('data-observed','1'); io.observe(e); });
  } else { els.forEach(function(e){ e.classList.add('is-in'); }); }

  var nums = document.querySelectorAll('.muse-stat__num:not([data-counted])');
  function run(el){
    el.setAttribute('data-counted','1');
    var end = parseInt(el.getAttribute('data-count'), 10) || 0;
    var pre = el.getAttribute('data-prefix') || '';
    var suf = el.getAttribute('data-suffix') || '';
    var cur = 0, step = Math.max(1, end / 60);
    var t = setInterval(function(){
      cur += step;
      if(cur >= end){ cur = end; clearInterval(t); }
      el.textContent = pre + Math.floor(cur).toLocaleString() + suf;
    }, 22);
  }
  if('IntersectionObserver' in window){
    var cio = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ run(en.target); cio.unobserve(en.target); } });
    }, { threshold: 0.5 });
    nums.forEach(function(n){ cio.observe(n); });
  } else { nums.forEach(run); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muse-testimonials"] && !Shopify.designMode) return;
  try {
    
(function(){
  var els = document.querySelectorAll('.muse-reveal:not([data-observed])');
  if(!('IntersectionObserver' in window)){ els.forEach(function(e){e.classList.add('is-in');}); return; }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { threshold: 0.18 });
  els.forEach(function(e){ e.setAttribute('data-observed','1'); io.observe(e); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muse-training-cta"] && !Shopify.designMode) return;
  try {
    
(function(){
  var els = document.querySelectorAll('.muse-reveal:not([data-observed])');
  if(!('IntersectionObserver' in window)){ els.forEach(function(e){e.classList.add('is-in');}); return; }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { threshold: 0.2 });
  els.forEach(function(e){ e.setAttribute('data-observed','1'); io.observe(e); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-header"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.muse-search [data-filter-toggle]').forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.stopPropagation();
      var f = btn.closest('[data-filter]');
      var open = f.classList.contains('is-open');
      document.querySelectorAll('.muse-search [data-filter].is-open').forEach(function(o){o.classList.remove('is-open');});
      if(!open){ f.classList.add('is-open'); }
    });
  });
  document.addEventListener('click', function(){
    document.querySelectorAll('.muse-search [data-filter].is-open').forEach(function(o){o.classList.remove('is-open');});
  });
  document.querySelectorAll('.muse-search .muse-filter__panel').forEach(function(p){
    p.addEventListener('click', function(e){ e.stopPropagation(); });
  });
  var sel = document.querySelector('.muse-search [data-sort]');
  if(sel){
    sel.addEventListener('change', function(){
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', this.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });
  }
  var els = document.querySelectorAll('.muse-search .muse-reveal');
  if(!('IntersectionObserver' in window)){ els.forEach(function(e){e.classList.add('is-in');}); return; }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); } });
  },{threshold:.08});
  els.forEach(function(e){io.observe(e);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('.muse-sr');
  if(!root) return;

  /* Sort: change updates URL param and reloads */
  var sort=root.querySelector('#muse-sr-sort-select');
  if(sort){
    sort.addEventListener('change',function(){
      var url=new URL(window.location.href);
      url.searchParams.set('sort_by',this.value);
      window.location.href=url.toString();
    });
  }

  /* Scroll reveal */
  var els=root.querySelectorAll('.muse-reveal');
  if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('is-in');});return;}
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(en){if(en.isIntersecting){en.target.classList.add('is-in');io.unobserve(en.target);}});
  },{threshold:.12});
  els.forEach(function(e){io.observe(e);});
})();

  } catch(e) { console.error(e); }
})();
})();
